import { render } from "./ShareMobile.vue?vue&type=template&id=619b58d0"
import script from "./ShareMobile.vue?vue&type=script&lang=js"
export * from "./ShareMobile.vue?vue&type=script&lang=js"

import "./ShareMobile.vue?vue&type=style&index=0&id=619b58d0&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__